import { useState, useEffect } from "react";
import { MessageCircle, Mail, X } from "lucide-react";
import { ACADEMY } from "../lib/academy-data";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waMessage = encodeURIComponent(
    "היי מעיין, אני מתעניין/ת באקדמיית הכדורסל הפועל מטה יהודה. אשמח לקבל פרטים נוספים."
  );
  const waUrl = `https://wa.me/${ACADEMY.managerWhatsapp}?text=${waMessage}`;
  const mailUrl = `mailto:${ACADEMY.managerEmail}?subject=${encodeURIComponent(
    "פנייה — אקדמיית כדורסל הפועל מטה יהודה"
  )}`;

  return (
    <div
      className={`fixed bottom-6 left-6 z-[60] flex flex-col-reverse items-start gap-3 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="floating-contact"
    >
      {/* Toggle button */}
      <button
        onClick={() => setOpen(!open)}
        aria-label={open ? "סגירה" : "יצירת קשר"}
        data-testid="floating-contact-toggle"
        className="w-14 h-14 inline-flex items-center justify-center bg-[#DC2626] hover:bg-[#B91C1C] text-white rounded-full shadow-[0_8px_30px_rgba(220,38,38,0.5)] hover:shadow-[0_8px_40px_rgba(220,38,38,0.75)] transition-all duration-300 hover:scale-105"
      >
        {open ? (
          <X size={24} strokeWidth={2.5} />
        ) : (
          <MessageCircle size={24} strokeWidth={2.5} fill="currentColor" />
        )}
      </button>

      {/* Action buttons */}
      <div
        className={`flex flex-col gap-3 transition-all duration-300 ${
          open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          data-testid="floating-whatsapp-btn"
          className="group flex items-center gap-3 bg-[#25D366] hover:bg-[#1FB957] text-white font-heading font-bold text-sm uppercase tracking-wider px-4 py-3 rounded-full shadow-[0_8px_20px_rgba(37,211,102,0.4)] transition-all duration-300 hover:scale-[1.03]"
        >
          <span className="font-body text-sm whitespace-nowrap">WhatsApp · {ACADEMY.manager}</span>
          <span className="w-9 h-9 inline-flex items-center justify-center bg-white/15 rounded-full">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </span>
        </a>

        <a
          href={mailUrl}
          aria-label="Email"
          data-testid="floating-email-btn"
          className="group flex items-center gap-3 bg-white hover:bg-neutral-100 text-[#0A0A0A] font-heading font-bold text-sm uppercase tracking-wider px-4 py-3 rounded-full shadow-[0_8px_20px_rgba(255,255,255,0.15)] transition-all duration-300 hover:scale-[1.03]"
        >
          <span className="font-body text-sm whitespace-nowrap">שליחת מייל</span>
          <span className="w-9 h-9 inline-flex items-center justify-center bg-[#DC2626] text-white rounded-full">
            <Mail size={18} strokeWidth={2.5} />
          </span>
        </a>
      </div>
    </div>
  );
}
